import { safeExternalUrl } from '../config/navigation.js'

// 当前契约只有全站APP下载地址，其它客户端不能冒用同一个安装包。
export function resolveAppDownloadUrl(config, appName, baseUrl) {
  if (appName !== '全站APP') return ''
  const value = String(config?.downloadUrl || '').trim()
  if (!value) return ''
  try {
    return safeExternalUrl(new URL(value, baseUrl).href)
  } catch { return '' }
}
